/**
 * Decides is `item` passes the filer against the `FilterCriteria`.
 */
export type FilterFunction<TItem, TFilterCriteria> = (item: TItem, criteria: TFilterCriteria) => boolean;

export function applyFilters<TItem, TFilterCriteria>(
  items: TItem[],
  filters: FilterFunction<TItem, TFilterCriteria>[],
  criteria: TFilterCriteria,
): TItem[] {
  return items.filter((item) => filters.every((filter) => filter(item, criteria)));
}
